import { ColorsEnum, Text } from './text';

interface IErrorMessageProps {
  className?: string;
  text?: string;
}

export const ErrorMessage = (props: IErrorMessageProps) => {
  if (!props.text) return null;
  return (
    <Text className={props.className} size='xs' color={ColorsEnum.Red}>
      {props.text}
    </Text>
  );
};
